import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=53ab4024&scoped=true"
import script from "./detail-dialog.vue?vue&type=script&lang=ts"
export * from "./detail-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab4024",
  null
  
)

export default component.exports